export interface CurrentUser {
  name: string;
  token: string;
  roles: UserRoles[];
}

export enum UserRoles {
  admin = 1,
  user = 2,
  none = 0,
}
